import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';


@Injectable()
export class GroupBudgetService {
  // private http: Http, 
  constructor(private authHttp: AuthHttp) { }

  getAllGroupBudget(year: number){
      return this.authHttp.get('/api/groupbudget/amountused/all/'+year).map( (res:any) =>{
        return { 'status': res.status, 'value': res.json() }
      } );
  }

  getGroupBudgetById(year: number,id: number){
    return this.authHttp.get('/api/groupbudget/amountused/'+year+'/'+id).map( (res:any) =>{
      return { 'status': res.status, 'value': res.json() }
    } );
  }

  getYearsAvailable(){
    return this.authHttp.get('/api/groupbudget/yearsavailable').map( (res:any) =>{
      return { 'status': res.status, 'value': res.json() }
    } );
  }

  getTicketsByGroupAndYear(year: number, group:number){
    return this.authHttp.get('/api/groupbudget/getAllTicketByGroup/'+year+'/'+group).map( (res:any) =>{
      return { 'status': res.status, 'value': res.json() }
    } );
  }


  addTicket(data:any){
    return this.authHttp.post('/api/groupbudget/addTicket',data).map( (res:any) =>{
      return { 'status': res.status, 'value': res.json() }
    } );
  }

  delTicket(id: number){
    return this.authHttp.delete('/api/groupbudget/deleteTicket/'+id).map( (res:any) =>{
      return { 'status': res.status, 'value': res.json() }
    } );
  }

  
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/groupBudget.service.ts